import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const BarChartBoxAiFill = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    title="BarChartBoxAiFill"
    {...props}
  >
    <g id="Icon" clipPath="url(#clip0_1656_29466)">
      <path
        id="Vector"
        d="M17.2605 7.0065L17.055 7.4779C16.9047 7.82301 16.4274 7.82301 16.2769 7.4779L16.0715 7.0065C15.7053 6.16597 15.0456 5.49675 14.2224 5.13064L13.5893 4.84909C13.2471 4.69685 13.2471 4.19875 13.5893 4.04651L14.187 3.78069C15.0313 3.40517 15.7028 2.71118 16.0628 1.8421L16.2738 1.33268C16.4208 0.977648 16.9112 0.977648 17.0582 1.33268L17.2692 1.8421C17.6292 2.71118 18.3007 3.40517 19.145 3.78069L19.7426 4.04651C20.0849 4.19875 20.0849 4.69685 19.7426 4.84909L19.1096 5.13064C18.2864 5.49675 17.6268 6.16597 17.2605 7.0065ZM18.3327 16.8997V9.11524C17.8113 9.29949 17.2504 9.39974 16.666 9.39974C15.7553 9.39974 14.9014 9.15624 14.166 8.73082V14.3997H12.4993V8.56641H13.9012C12.5539 7.67064 11.666 6.13888 11.666 4.39974C11.666 3.81535 11.7663 3.25437 11.9505 2.73307H2.49935C2.03912 2.73307 1.66602 3.10617 1.66602 3.56641V16.8997C1.66602 17.36 2.03912 17.7331 2.49935 17.7331H17.4993C17.9596 17.7331 18.3327 17.36 18.3327 16.8997ZM5.83268 11.0664H7.49935V14.3997H5.83268V11.0664ZM9.16602 6.06641H10.8327V14.3997H9.16602V6.06641Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1656_29466">
        <rect width={20} height={20} fill="white" transform="translate(0 0.234375)" />
      </clipPath>
    </defs>
  </svg>
);
export default React.memo(BarChartBoxAiFill);
